jQuery(document).ready(function ($) {
  $(window).on('load', function () {
    //Swiper header
    const swiperHeader = jQuery('#headerSwiper .swiper');
    let swiperHeaderInstance = swiperHeader.data('swiper');
    let originalParams;

    if (swiperHeaderInstance) {
      originalParams = { ...swiperHeaderInstance.params }; // Save original params

      function updateSwiperParams() {
        if (window.innerWidth < 576) {
          swiperHeaderInstance.params.centeredSlides = true;
          swiperHeaderInstance.params.slidesPerView = 1.5;
          swiperHeaderInstance.params.watchSlidesVisibility = true;
          swiperHeaderInstance.params.breakpoints = {
            576: {
              slidesPerView: 3,
            },
          };
        } else {
          swiperHeaderInstance.params = { ...originalParams }; // Restore original params
          swiperHeaderInstance.params.loop = true;
        }
        swiperHeaderInstance.destroy(false);
        new Swiper('#headerSwiper .swiper', swiperHeaderInstance.params);
      }

      updateSwiperParams();
      $(window).on('resize', updateSwiperParams);
    }

    //Swiper cards
    const swiperCards = jQuery('#cardSwiper .swiper');
    const swiperCardsInstance = swiperCards.data('swiper');
    if (swiperCardsInstance) {
      swiperCardsInstance.params.effect = 'cards';
      swiperCardsInstance.params.direction = 'vertical';
      swiperCardsInstance.params.cardsEffect = {
        slideShadows: false,
      };
      swiperCardsInstance.destroy(false);
      new Swiper('#cardSwiper .swiper', swiperCardsInstance.params);
    } else {
      console.error('Swiper instance not found on the element:', swiperCards);
    }
  });
});
